import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Tab, Tabs } from "react-bootstrap";

export const HtmlPreviewMultiDevice = ({ show, toggle, htmlData }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} size="xl" onHide={toggle} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Offer Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="global-tab">
        <Tabs
          defaultActiveKey="desktop"
          id="uncontrolled-tab-example"
          className="mb-3 preview-tab"
        >
          <Tab
            eventKey="desktop"
            title={
              <span>
                <span className="material-symbols-outlined display-icon mb-1">
                  desktop_windows
                </span>
                Desktop
              </span>
            }
          >
            <div className="relative text-content">
              <div className="display-img display-desktop text-center">
                <img src="/assets/images/desktop-display.svg" alt="" />
              </div>
              <div className="display-view desktop-view">
                <div
                  className="p-4"
                  dangerouslySetInnerHTML={{
                    __html: htmlData,
                  }}
                />
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="tablet"
            title={
              <span>
                <span className="material-symbols-outlined display-icon mb-1">
                  tablet_mac
                </span>
                Tablet
              </span>
            }
          >
            <div className="relative text-content">
              <div className="display-img display-tablet text-center">
                <img src="/assets/images/tablet-display.svg" alt="" />
              </div>
              <div className="display-view tablet-view">
                <div
                  className="p-4"
                  dangerouslySetInnerHTML={{
                    __html: htmlData,
                  }}
                />
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="mobile"
            title={
              <span>
                <span className="material-symbols-outlined display-icon mb-1">
                  smartphone
                </span>
                Mobile
              </span>
            }
          >
            <div className="relative text-content">
              <div className="display-img display-mobile text-center">
                <img src="/assets/images/mobile-display.svg" alt="" />
              </div>
              <div className="display-view mobile-view">
                <div
                  className="p-4"
                  dangerouslySetInnerHTML={{
                    __html: htmlData,
                  }}
                />
              </div>
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};
